<template>
    <div class="advanced-collate layout-sub-page">
        <!-- 1. 搜索tab -->
        <div class="title-bar dsp-flex">
            <div class="title-side title-left">
                <span @click="clickCancel">取消</span>
            </div>
            <div class="title-middle">
                <span>四柱起盘</span>
            </div>
            <div class="title-side title-green" @click="clickCollate">起盘</div>
        </div>

        <!-- 2. 主要表单输入部分 -->
        <advanced-collate-form
            v-bind:itemSize="itemSize"
            v-bind:basicPos="basicPos"
            v-bind:chooseGroupFunc="clickChooseGroup"
            v-bind:chooseLabelFunc="clickChooseLabel">
        </advanced-collate-form>
    </div>
</template>

<script>
import { DOM } from '../../modules/dom';
import { MOMENT_TIME } from '../../modules/momenttime';
import AdvancedCollateForm from '../../layouts/collate/AdvancedCollateForm.vue'
export default {
    name: 'AdvancedCollate',
    components: { AdvancedCollateForm },
    data() {
        return {
            itemSize: {width: 0, height: 0},
            basicPos: {x: 0, y: 0}  //第一个item的值，用来计算点击item的pos值，以确定三角形的定位
        }
    },
    computed: {
        choosedGroup() {
            return this.$store.state.group.choosedGroup;
        },
        selectedLabelString() {
            return this.$store.state.label.selectedLabelString;
        },
        formData() {
            return this.$store.state.collate.formData;
        },
        siZhuEightWordArr() {
            return this.$store.state.collate.advanced.siZhuEightWordArr;
        },
        showChooseItemPop() {
            return this.$store.state.collate.advanced.showChooseItemPop;
        },
        sameEightWordList() {
            return this.$store.state.collate.advanced.sameEightWordList;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    mounted: function() {
        if(this.siZhuEightWordArr.length == 0){
            this.$router.replace('/collate');
            return;
        }
        // 设置二级页面的高度
        this.$el.style.width = innerWidth + 'px'
        this.$el.style.height = innerHeight + 'px';
        this.$el.style.overflow = 'hidden';
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('title-bar')[0];
            var mainDiv = document.getElementsByClassName('advanced-collate-main')[0];
            var formDiv = document.getElementsByClassName('advanced-collate-form')[0];
            var titleDiv = document.getElementsByClassName('layout-asb-title')[0];
            var itemBoxDiv = document.getElementsByClassName('layout-asb-item')[0];
            var itemDiv = document.getElementsByClassName('layout-asb-box')[0];

            mainDiv.style.paddingTop = topDiv.clientHeight + 'px';
            // 初始化基础数据
            var x = parseInt(itemBoxDiv.clientWidth / 2) - 6 , y = topDiv.clientHeight + formDiv.clientHeight + titleDiv.clientHeight + itemDiv.clientHeight - 10;
            this.$set(this.basicPos, 'x', x);
            this.$set(this.basicPos, 'y', y);
            this.$set(this.itemSize, 'width', itemBoxDiv.clientWidth);
            this.$set(this.itemSize, 'height', (itemDiv.clientHeight + 20));
            // console.log('initDom----', this.choosedGroup, this.basicPos, this.itemSize)
        },
        clickCancel() {
            DOM.showPageByClassName('collate-page');
            this.$router.replace('/collate');
        },
        clickCollate() {
            // 处理未填的参数，设置为默认值
            this.formData.sex = this.formData.sex == '' ? 0 : this.formData.sex;
            this.formData.f_name = this.formData.f_name == '' ? '未命名' : this.formData.f_name;
            this.formData.f_group = this.choosedGroup.id ? this.choosedGroup.id : 0;
            // 处理早晚子时:
            this.formData.zwzs = parseInt(this.settingConfigData.zaoWanZiShi);
            // 处理生日时间:返回之后时间没有默认设置了,设置一个默认值；
            var starttime = this.formData.birthday == '' ? MOMENT_TIME.getTimeStampByNow() : this.formData.birthday;
            if(typeof(starttime) == 'number') {
                this.formData.birthday = MOMENT_TIME.getFormateTimeByTimeStamp(starttime * 1000);
            }
            // 处理标签及备注信息
            this.formData.label = this.$store.state.label.selectedLabelId;
            this.formData.remark = this.$store.state.label.remarkStringData;

            console.log('起盘:::::::', this.formData, this.choosedGroup)
            var me = this;
            this.$store.state.collate.curStartCollateType = 'sizhu';
            this.$store.dispatch('record/checkRecordListSameSiZhu', {
                formData: this.formData,
                cb: function() {
                    me.$store.dispatch('collate/submitSiZhuCollate', me.formData);
                }
            })
        },
        clickChooseGroup() {
            this.$store.state.collate.chooseGroupFromPage = '/collate/advancedcollate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/choosegroup');
        },
        clickChooseLabel() {
            this.$store.state.collate.chooseLabelFromPage = '/collate/advancedcollate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/label');
        },

    }
}
</script>